/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type productPage_product$ref: FragmentReference;
export type productPage_product = {|
  +slug: string,
  +name: string,
  +variant: string,
  +summary: string,
  +description: string,
  +releaseDate: ?string,
  +shippingFromDate: ?string,
  +discountInfo: ?string,
  +nominationsUntil: ?string,
  +nominationsLink: ?string,
  +nominationsColor: ?string,
  +picture: string,
  +shopifyProduct: ?string,
  +shopifyDigitalProduct: ?string,
  +productLabel: ?string,
  +digitalProductLabel: ?string,
  +shopifyBundle: ?string,
  +shopifyBundleLabel: ?string,
  +seo: ?{|
    +title: ?string,
    +description: ?string,
  |},
  +social: ?{|
    +twitter: ?$ReadOnlyArray<?{|
      +type: ?string,
      +title: ?string,
      +image: ?string,
      +handle: ?string,
      +description: ?string,
    |}>,
    +generic: ?$ReadOnlyArray<?{|
      +title: ?string,
      +image: ?string,
      +description: ?string,
    |}>,
  |},
  +city: {|
    +slug: string,
    +name: string,
    +color: ?string,
    +articles: $ReadOnlyArray<{|
      +slug: ?string,
      +title: ?string,
      +caption: ?string,
      +readingTime: ?number,
      +picture: ?string,
      +author: ?{|
        +firstname: ?string,
        +lastname: ?string,
      |},
    |}>,
  |},
  +shipping: string,
  +pictures: $ReadOnlyArray<string>,
  +content: $ReadOnlyArray<{|
    +title: string,
    +icon: string,
  |}>,
  +preview: $ReadOnlyArray<string>,
  +quotes: ?$ReadOnlyArray<{|
    +quote: string,
    +author: string,
    +organisation: string,
    +link: string,
  |}>,
  +sponsors: $ReadOnlyArray<{|
    +logo: ?string,
    +link: ?string,
  |}>,
  +communityPartners: $ReadOnlyArray<{|
    +logo: ?string,
    +link: ?string,
  |}>,
  +$refType: productPage_product$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "picture",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v7 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "logo",
    "args": null,
    "storageKey": null
  },
  v6
];
return {
  "kind": "Fragment",
  "name": "productPage_product",
  "type": "Product",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "variant",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "summary",
      "args": null,
      "storageKey": null
    },
    v2,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "releaseDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shippingFromDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "discountInfo",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "nominationsUntil",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "nominationsLink",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "nominationsColor",
      "args": null,
      "storageKey": null
    },
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shopifyProduct",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shopifyDigitalProduct",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "productLabel",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "digitalProductLabel",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shopifyBundle",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shopifyBundleLabel",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seo",
      "storageKey": null,
      "args": null,
      "concreteType": "SEO",
      "plural": false,
      "selections": [
        v4,
        v2
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "social",
      "storageKey": null,
      "args": null,
      "concreteType": "SocialMedia",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "twitter",
          "storageKey": null,
          "args": null,
          "concreteType": "TwtrSlices",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "type",
              "args": null,
              "storageKey": null
            },
            v4,
            v5,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "handle",
              "args": null,
              "storageKey": null
            },
            v2
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "generic",
          "storageKey": null,
          "args": null,
          "concreteType": "GenSocialSlices",
          "plural": true,
          "selections": [
            v4,
            v5,
            v2
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "city",
      "storageKey": null,
      "args": null,
      "concreteType": "City",
      "plural": false,
      "selections": [
        v0,
        v1,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "color",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "articles",
          "storageKey": "articles(first:3)",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 3,
              "type": "Int"
            }
          ],
          "concreteType": "Article",
          "plural": true,
          "selections": [
            v0,
            v4,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "caption",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "readingTime",
              "args": null,
              "storageKey": null
            },
            v3,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "author",
              "storageKey": null,
              "args": null,
              "concreteType": "Author",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "firstname",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "lastname",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shipping",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pictures",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "content",
      "storageKey": null,
      "args": null,
      "concreteType": "ProductContent",
      "plural": true,
      "selections": [
        v4,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "icon",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "preview",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "quotes",
      "storageKey": null,
      "args": null,
      "concreteType": "ProductQuote",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "quote",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "author",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "organisation",
          "args": null,
          "storageKey": null
        },
        v6
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sponsors",
      "storageKey": null,
      "args": null,
      "concreteType": "Partner",
      "plural": true,
      "selections": v7
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "communityPartners",
      "storageKey": null,
      "args": null,
      "concreteType": "Partner",
      "plural": true,
      "selections": v7
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '65fc2c8c55145fdceafe6832bb2e89c8';
module.exports = node;
